
// .fn-formValidate フォームバリデート
(function($) {

	let element = '.fn-formValidate';
	let $element = $(element);
	if (! $element[0]) {
		return;
	}

	function implodeInput(name, glue){
		$('[data-input-group="'+name+'"] input').blur(function(){
			var value = (function(slctr, glue){
				var glue = glue || ',';
				var txt = '', txt2 = '', val = '';
				$(slctr).each(function(index, el) {
					val = $(el).val();
					if(index != 0 && val != '') txt += glue;
					txt += val;
					txt2 += val;
				});
				if(txt2 == '') return '';
				return txt;
			})('[data-input-group="'+name+'"] input',glue);
			$('input[name="'+name+'"]').val(value);
		});
	}
	function validateForm(element) {
		var element = (element !== undefined) ? element: 'form';
		var ret = true;
		$('[data-config]', element).each(function(index, el) {
			if(!validateInput(el)){
				ret = false;
			}
		});
		return ret;
	}
	function validateInput(el) {
		let name = $('[name]', el).attr('name');
		let val = $('[name]', el).val();
		let config = $(el).data('config');
		let flag = true;
		// 必須チェック
		if(config.required === true){
			// まず全体チェック
			if(val === ''){
				flag = false;
			}
			// 入力グループの必須チェック
			$('[data-input-group] input', el).each(function(index, el) {
				if($(el).val() === '' && $(el).hasClass('typed')){
					flag = false;
				}
			});
			if(flag === false){
				$('[data-message]', el).text(config.requiredError);
				$(el).addClass('is-error');
				return false;
			}
		}
		// チェックボックスのチェック
		if(config.checked === true){
			if(!$('[type="checkbox"]:checked, [type="radio"]:checked', el).val()){
				$('[data-message]', el).text(config.checkedError);
				$(el).addClass('is-error');
				return false;
			}
		}
		// 正規表現チェック
		if(config.type !== ''){
			let regex = $(el).attr('data-regex');
			if(typeof regex !== 'undefined' && regex !== false){
				if(!val.match(regex)){
					$('[data-message]', el).text(config.typeError);
					$(el).addClass('is-error');
					return false;
				}
			}
		}
		$('[data-message]', el).text('');
		$(el).removeClass('is-error');
		return true;
	}

	/* 入力欄のactive装飾
	======================================== */
	$('input, textarea').focus(function(){
		$(this).addClass('is-active');
		$(this).addClass('is-typed');
	}).blur(function(){
		$(this).removeClass('is-active');
	});

	/* input（data-input-group属性）のval結合
	======================================== */
	// implodeInput('お名前','　');
	// // フリガナ
	// implodeInput('フリガナ','　');
	// // 電話番号
	// implodeInput('電話番号','-');

	/* Validate
	======================================== */
	// テキストボックス
	$('[data-config] input, [data-config] textarea', element).blur(function(){
		validateInput($(this).parents('[data-config]'));
	});
	// チェックボックス
	$('[data-config] input[type="checkbox"]', element).change(function(){
		validateInput($(this).parents('[data-config]'));
	});
  // チェックボックス
	$('[data-config] input[type="radio"]', element).change(function(){
		validateInput($(this).parents('[data-config]'));
	});
	// 送信ボタン
	$('button[type="submit"]', element).on('click', function(e) {
		e.preventDefault();
		if( validateForm() ) {
			//$(this).prop('disabled', true);
			$(element).submit();
		}
	});

})(jQuery);
